export enum ConditionTermsSource {
  newAccount = 'NEW_ACCOUNT',
  dataValidation = 'DATA_VALIDATION',
}
